import React from 'react';
import {InfoCircleOutlined, LoadingOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import {useTranslation} from 'react-i18next';
import './PovScopeNotice.css';

const normalizePovLabel = (value) => String(value || '').trim();

const PovScopeNotice = ({
    partyRole,
    studiedPartyName,
    commentsCount = 0,
    loading = false,
    transitioning = false,
    transitionPartyName,
}) => {
    const {t} = useTranslation('review');
    const partyName = normalizePovLabel(studiedPartyName);
    const role = normalizePovLabel(partyRole);
    const nextPartyName = normalizePovLabel(transitionPartyName) || partyName;
    const hasCompletePov = Boolean(role && partyName);
    const isLoading = Boolean(transitioning || (loading && hasCompletePov));

    const statusKey = isLoading
        ? 'loading'
        : !hasCompletePov
            ? 'incomplete'
            : commentsCount > 0
            ? 'ready'
            : 'empty';

    const headline = statusKey === 'loading'
        ? t('pov_scope.loadingWithParty', {
            partyName: nextPartyName,
            defaultValue: nextPartyName
                ? 'Chargement des résultats pour {{partyName}}…'
                : 'Chargement des résultats…',
        })
        : statusKey === 'incomplete'
            ? t('pov_scope.select')
            : `${t('pov_scope.eyebrow')} ${partyName}`;
    const status = statusKey === 'incomplete'
        ? headline
        : t(`pov_scope.${statusKey}`);

    return (
        <Tooltip
            placement="bottom"
            title={(
                <div className="pov-scope-tooltip">
                    <strong>{headline}</strong>
                    {status !== headline && <span>{status}</span>}
                </div>
            )}
        >
            <span
                className={`pov-scope-notice is-${statusKey}`}
                aria-label={headline}
                aria-live="polite"
            >
                <span className="pov-scope-notice__icon" aria-hidden="true">
                    {isLoading ? <LoadingOutlined spin/> : <InfoCircleOutlined/>}
                </span>
                {statusKey === 'ready' || statusKey === 'empty' ? (
                    <>
                        <span className="pov-scope-notice__eyebrow">
                            {t('pov_scope.eyebrow')}
                        </span>
                        <strong className="pov-scope-notice__party">{partyName}</strong>
                    </>
                ) : (
                    <strong className="pov-scope-notice__party">{headline}</strong>
                )}
            </span>
        </Tooltip>
    );
};

export default PovScopeNotice;
